import React from "react";
import ReactApexChart from "react-apexcharts";

const ApexLine3 = ({ categories, data }) => {
  const options = {
    chart: {
      height: 350,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [4],
      colors: ["#363062"],
      curve: "straight",
    },
    xaxis: {
      type: "category",
      categories: categories,
    },
    colors: ["#363062"],
    markers: {
      size: [6],
      strokeWidth: [4],
      strokeColors: ["#363062"],
      border: 0,
      colors: ["#fff"],
      hover: {
        size: 10,
      },
    },
    yaxis: {
      max: 100,
    },
  };

  const series = [
    {
      name: "متوسط تحقيق نواتج التعلم",
      data: data,
    },
  ];

  return (
    <div id="chart" className="area-chart">
      <ReactApexChart options={options} series={series} type="area" height={350} />
    </div>
  );
};

export default ApexLine3;
